"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordPage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var main_1 = require("../../../reducers/slices/main");
var react_router_dom_1 = require("react-router-dom");
var reset_password_1 = require("../../../api/calls/user/authentication/reset_password");
var validate_password_1 = require("../../../api/calls/user/authentication/validate_password");
var ResetPasswordPage = function () {
    var params = (0, react_router_dom_1.useParams)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var user = (0, react_redux_1.useSelector)(function (state) { return state.userState; }).user;
    var resetCode = params.resetCode;
    var _a = (0, react_1.useState)(""), password = _a[0], setPassword = _a[1];
    var _b = (0, react_1.useState)(""), rePassword = _b[0], setRePassword = _b[1];
    var _c = (0, react_1.useState)(""), passwordError = _c[0], setPasswordError = _c[1];
    var _d = (0, react_1.useState)(""), rePasswordError = _d[0], setRePasswordError = _d[1];
    var _e = (0, react_1.useState)(""), errorText = _e[0], setErrorText = _e[1];
    var _f = (0, react_1.useState)(""), successText = _f[0], setSuccessText = _f[1];
    var _g = (0, react_1.useState)(false), isButtonLoading = _g[0], setIsButtonLoading = _g[1];
    var _h = (0, react_1.useState)(false), isPasswordChanged = _h[0], setIsPasswordChanged = _h[1];
    var validate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var messageCount, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPasswordError("");
                    setRePasswordError("");
                    setErrorText("");
                    setSuccessText("");
                    messageCount = 0;
                    if (!password) {
                        messageCount++;
                        setPasswordError("Password is required!");
                    }
                    if (!rePassword) {
                        messageCount++;
                        setRePasswordError("Password is required!");
                    }
                    if (password && rePassword) {
                        if (password != rePassword) {
                            messageCount++;
                            setRePasswordError("Passwords do not match.");
                        }
                    }
                    if (!password) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, validate_password_1.validate_password)(password)];
                case 1:
                    response = _a.sent();
                    if (!response.success) {
                        messageCount++;
                        setPasswordError(response.message);
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/, messageCount ? false : true];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement("div", { className: "relative" },
            react_1.default.createElement("div", { className: "flex flex-row justify-center" },
                react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, null,
                    react_1.default.createElement("div", { className: "flex flex-col items-center" },
                        react_1.default.createElement("div", { className: "w-[400px] md:w-[600px] lg:w-[800px] flex flex-col gap-y-4 p-8" },
                            react_1.default.createElement(doshx_controls_web_1.BoxControl, { className: "bg-white shadow-md", variant: "filled", addPadding: false },
                                react_1.default.createElement("div", { className: "flex flex-col gap-4  p-8 " },
                                    react_1.default.createElement("div", { className: "flex flex-col gap-4" },
                                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { size: "small", label: "New Password", type: "password", value: password, onChange: function (v) { return setPassword(v); }, errorText: passwordError, disabled: isButtonLoading, required: true }),
                                        react_1.default.createElement(doshx_controls_web_1.TextInputControl, { size: "small", label: "Confirm New Password", type: "password", value: rePassword, onChange: function (v) { return setRePassword(v); }, errorText: rePasswordError, disabled: isButtonLoading, required: true })),
                                    react_1.default.createElement("div", { className: "flex gap-1" },
                                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: successText, size: "medium", textColor: "text-success" }),
                                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: errorText, size: "medium", textColor: "text-red-500" })),
                                    react_1.default.createElement("div", { className: "flex flex-row justify-start" },
                                        react_1.default.createElement(doshx_controls_web_1.ButtonControl, { size: "small", label: "Reset Password", backgroundColor: "bg-secondary", loading: isButtonLoading, enabled: !isButtonLoading && !isPasswordChanged, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                                var response;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            setIsButtonLoading(true);
                                                            return [4 /*yield*/, validate()];
                                                        case 1:
                                                            if (!_a.sent()) return [3 /*break*/, 3];
                                                            return [4 /*yield*/, (0, reset_password_1.reset_password)({ code: resetCode !== null && resetCode !== void 0 ? resetCode : "", password: password })];
                                                        case 2:
                                                            response = _a.sent();
                                                            if (response.success) {
                                                                setSuccessText(response.message);
                                                                setIsPasswordChanged(true);
                                                                setIsButtonLoading(response.content.is_loading);
                                                                if (!user.uid) {
                                                                    dispatch((0, main_1.setDrawerPage)("login"));
                                                                    dispatch((0, main_1.setDrawerOpen)(true));
                                                                }
                                                            }
                                                            else {
                                                                setErrorText(response.message);
                                                                setIsButtonLoading(response.content.is_loading);
                                                            }
                                                            return [3 /*break*/, 4];
                                                        case 3:
                                                            setIsButtonLoading(false);
                                                            _a.label = 4;
                                                        case 4: return [2 /*return*/];
                                                    }
                                                });
                                            }); } })))))))))));
};
exports.ResetPasswordPage = ResetPasswordPage;
